<!--<button class="btn btn-primary btn-block" (click)="launchRipple()">test ripple</button>-->
@if (appService.user) {

<div class="animated faster fadeInUp">
	<div matRipple #ticketRipple matRippleDisabled="true">
		<div class="p-3">
		@if ($storage.hasOffers) {
			<div class="alt-panel ">
				<div class="alt-panel-header" (mousedown)="tabitPayService.detailsCollapsed = !tabitPayService.detailsCollapsed">
					<div class="text-accent" style="flex-grow: 1">
						{{ $storage.order?.tabName }}
						<small style="display: block;">{{ 'PO.ORDER_NO' | translate }}:&nbsp;<b class="text-accent">{{ $storage.order?._order?.number }}</b></small>
					</div>

					<mat-icon color="accent" class="lg ml-2">{{tabitPayService.detailsCollapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</mat-icon>
				</div>
				@if (!tabitPayService.detailsCollapsed) {
					<div class="alt-panel-body data-rows-condensed pt-0" [ngClass]="{'animated faster zoomIn': tabitPayService.detailsCollapsed === false}" >

						@if (appService.regionArgs.showDetailedFees && $storage.order.printData?.collections?.FEES[0]) {
							@if ($storage.order.printData.variables.INCLUSIVE_NET_AMOUNT != $storage.order.printData.variables.TOTAL_AMOUNT) {
								<div class="basket-summary-row">
									<div class="_title">{{ 'Subtotal' | translate }}</div>
									<div
										class="_price">{{ $storage.order.printData.variables.INCLUSIVE_NET_AMOUNT | lcurrency:'1.2-2' }}
									</div>
								</div>
							}
							@for (fee of $storage.order.printData?.collections?.FEES; track fee) {
								@if (fee.AMOUNT) {
									<div class="basket-summary-row">
										<div class="_title">{{ fee.NAME }}</div>
										<div class="_price">{{ fee.AMOUNT | lcurrency:'1.2-2' }}</div>
									</div>
								}
							}
						}
						<div class="basket-summary-row">
							<div class="_title">{{ 'PO.ORDER_TOTAL' | translate }}</div>
							<div
								class="_price">{{ $storage.order.printData.variables.TOTAL_AMOUNT | lcurrency }}
							</div>
						</div>


						@if ($storage.order.isTabOwner) {
							@if ($storage.order.printData.variables.TOTAL_PAYMENTS) {
								<div class="basket-summary-row">
									<div class="_title">{{ 'PO.PAID' | translate }}</div>
									<div
										class="_price">{{ ($storage.order.printData.variables.TOTAL_PAYMENTS - $storage.order.printData.variables.CHANGE) | lcurrency }}
									</div>
								</div>
							}
							@if ($storage.order.tabLimit) {
								<hr>
								<div class="basket-summary-row">
									<div class="_title">{{ 'OAT.current_preauth' | translate }}</div>
									<div class="_price text-highlight">{{ $storage.order.tabLimit | lcurrency }}
									</div>
								</div>
								<div class="basket-summary-row">
									<div class="_title">{{ 'OAT.remaining_preauth' | translate }}</div>
									<div
										class="_price text-highlight">{{ ($storage.order.tabLimit - $storage.order.balanceDue) | lcurrency }}
									</div>
								</div>
							}
						}

						<div class="basket-summary-row font-bold text-accent" style="font-size: 1.2em">
							<div class="_title">{{ 'PO.REMAINED_PAY' | translate }}</div>
							<div class="_price">{{ $storage.order.printData.variables.BAL_DUE | lcurrency }}
							</div>
						</div>

						@if ($storage.order.totals.discounts?.total) {
							<div class="tip-container">
								<div class="image-icon-badge mr-2"><mat-icon svgIcon="box_full"></mat-icon></div>
								<span class="_content">{{ 'PO.ORDER_DISCOUNT' | translate }}</span>
								<div class="_price">
									{{ $storage.order.totals.discounts?.total | lamount }}
								</div>
							</div>
						}


						@if ($storage.order.payments?.length) {
							<div class="tip-container mb-2">
								<span class="_content">{{ 'received_payments' | translate }}</span>
							</div>
							@for ( pm of $storage.order.payments ; track pm) {
								<div class="basket-summary-row">
									<div class="_title">{{ pm.name | translate }}</div>
									<small class="inline mr-2" *ngIf="pm.tip">
										(<span class="inline">{{ 'gratuity' | translate }}: </span>
										{{ pm.tip | lcurrency:'1.2-2' }})
									</small>
									<div class="_price">{{ pm.total | lcurrency:'1.2-2' }}</div>
								</div>
							}
						}

						@if ($storage.enableGratuity && $storage.showPrices && $storage.hasOffers && $storage.order.totalPayments) {
							<div class="tip-container text-accent" (click)="_onTicketAction('full_tip')">
								<div class="image-icon-badge mr-2"><mat-icon svgIcon="heart"></mat-icon></div>
								<span class="_content">{{($storage.order.totalTips ? 'want_to_add_more_tip' : 'want_to_add_tip') | translate}}</span>
								<mat-icon svgIcon="chevron_next" class="base rotate-rtl"></mat-icon>
							</div>
						}
					</div>
				}
			</div>

			@if (!$storage.order.printData.variables.BAL_DUE) {
				<div class="alert alert-success d-flex align-items-center justify-content-center mt-3 mb-0">
						<mat-icon class="mr-3 lg">check</mat-icon>
						<div class="_title">{{ 'order_payed_in_full' | translate }}</div>
				</div>
			}
		} @else {
			<div class="alt-panel">
				<div class="alt-panel-body">
					<div class="basket-summary-row">
						<div class="_title">
							{{ $storage.order?.tabName }}
							<small style="display: block">{{ 'PO.ORDER_NO' | translate }}:&nbsp;<b class="text-accent">{{ $storage.order?._order?.number }}</b></small>
						</div>
					</div>
					@if ($storage.order.tabLimit) {
						<div class="data-rows-condensed">
							<div class="alt-data-row">
								<div>{{ 'OAT.current_preauth' | translate }}</div>
								<div class="text-highlight">{{ $storage.order.tabLimit | lcurrency }}</div>
							</div>
						</div>
					}
				</div>
			</div>
		}
		</div>

		<!--  START TICKET ==================================================== -->

		<div class="">
			@if ($storage.order.diners) {
				<div class="p-3 px-4 order-ticket-diners border-bottom" [class._more]="$storage.order.diners.length > 7">
					@for (diner of $storage.order.diners; track diner) {
						<div class="order-ticket-diner">
							<div class="order-ticket-diner-icon" [style.background]="diner.background"
								 (mousedown)="showDinerOffers(diner)"
								 [ngClass]="{'isme':diner.isMe, isowner: diner.isOwner}" [class.isme]="diner.isme">
								<!--@if (diner.offers.length) {
									<span class="diner-badge"
										  [style.background]="diner.background">{{ diner.offers.length }}</span>
								}-->
								@if (diner.isOwner) {
									<mat-icon svgIcon="crown" class="md"></mat-icon>
								} @else {
									{{ diner.initials }}
								}
								<!--@if (diner.isOwner) {
									<span class="owner-badge" [style.color]="diner.background"><mat-icon inline>verified_user</mat-icon></span>
								}-->
							</div>
							<div class="_label">{{diner.caption}}</div>
						</div>
					}
				</div>
			}


			@if ($storage.order.pendingOffers) {
				<div class="p-3" style="font-size: 0.9em">
					<div class="alt-panel warning">
						<div class="alt-panel-body">
							<b style="font-size: 1.1em; margin-bottom: 0.5rem; ">
								{{ 'OAT.offers_pending_approval' | translate }}
							</b>
							@for (item of $storage.order.pendingOffers; track item._id; let last = $last) {
								<div class="basket-summary-row" [class.border-bottom]="!last" style="padding: 12px 0;">
									<div class="_title">
										<div>
											{{ item.name }}
										</div>
									</div>
									<app-inline-diners [diners]="[item._diner]" class="_shadow"></app-inline-diners>
									<div class="_price"
										 style="min-width: 50px; text-align: end; margin-inline-start: 5px;">{{ item.amount | lamount }}
									</div>
								</div>
							}
							@if ($storage.order.isTabOwner) {
								<div class="d-flex justify-content-between mt-2">
									<button matButton="outlined" color="accent" (click)="_approveAllPendingOffers()">
										<mat-icon svgIcon="check"></mat-icon>
										{{ 'OAT.offers_approve-all' | translate }}
									</button>

									<button matButton="filled" color="accent"
											(click)="_approveDeclineAllPendingOffers()">
										<mat-icon svgIcon="pen"></mat-icon>
										{{ 'OAT.offers_approve-decline' | translate }}
									</button>
								</div>
							}
						</div>
					</div>
				</div>
			}

			<div style="font-size: 0.9em">
				@if ($storage.hasOffers) {
					@for (item of $storage.order.offerDiners | keyvalue; track item; let last = $last) {
						<div class="basket-summary-row" [class.border-bottom]="!last" style="padding: 12px 1.5rem;">
							<div class="_title">
								<div>
									@if (item.value.count > 1) {
										<span style="display: inline-block">{{ item.value.count }}x</span>
									}
									{{ item.value.name }}
								</div>
								@if (item.value.discount) {
									<div style="transform: scale(0.8); position: relative; margin-inline-start: -6px;" class="text-accent d-inline-flex align-items-center">
										<mat-icon svgIcon="box_full" class="mr-1"></mat-icon>
										<div>{{ item.value.discount | lamount }}</div>
									</div>
								}
							</div>
							<app-inline-diners [diners]="item.value.diners" class="_shadow"></app-inline-diners>
							<div class="_price" style="min-width: 50px; text-align: end; margin-inline-start: 5px;"
								 [ngClass]="{'text-wave': item.value.onTheHouse}">
								{{ item.value.amount | lamount }}
							</div>
						</div>
					}
				} @else if (!$storage.order.pendingOffers) {
					<div class="text-center pt-4">
						<img src="assets/images/pendingdata.svg">
						<div class="text-md text-muted font-bold pre-wrap mt-3">{{ 'TO.add_items_prompt' | translate }}</div>
					</div>
				}
			</div>
		</div>
		<!--<app-power-by-tabit></app-power-by-tabit>-->
		<!--  END TICKET ==================================================== -->
	</div>
</div>

@if (!$storage.restricted && !$storage.order.closed) {
<div class="p-3 pb-4 fixed-bottom animated fadeInUp">

	<!--<h4 style="display: flex; align-items: center; justify-content: space-between">
		<span>enablePay: [{{$storage.enablePay}}]</span>
		<span>canPay: [{{ $storage.order.canPay }}]</span>
	</h4>-->

	@if ($storage.order.isTabOrderPreAuth) {
		@if ($storage.enableAddItems) {
			<button mat-raised-button color="accent" class="lg rounded btn-block mt-2" type="button"
					(click)="appService.addItemsToOrder()">
				{{ 'add-items' | translate }}
			</button>
		}
		@if ($storage.order.authorization) {
			@if ($storage.order.isTabOwner) {
				@if ($storage.enablePay && $storage.order.canPay) {
					<button mat-raised-button color="primary" class="lg rounded btn-block mt-2" type="button"
							(click)="_onTicketAction('openTabAllowNonDeposit')">
						{{ 'OAT.select_how_to_pay' | translate }}
					</button>
				} @else {
					<button mat-raised-button color="primary" class="lg rounded btn-block mt-2" type="button"
							(click)="manageTab()">
						{{ 'OAT.manage-tab-order' | translate }}
					</button>
				}
			} @else if ($storage.enablePay && $storage.order.canPay) {
				<button mat-raised-button color="primary" class="lg rounded btn-block mt-2" type="button"
						(click)="_onTicketAction()">
					{{ 'OAT.select_how_to_pay' | translate }}
				</button>
			}
		}
	} @else {
		@if ($storage.enableAddItems) {
			<button mat-raised-button color="primary" class="lg rounded btn-block mt-2" type="button"
					(click)="appService.addItemsToOrder()">
				{{ 'add-items' | translate }}
			</button>
		}
		@if ($storage.enablePay && $storage.order.canPay) {
			<button mat-raised-button color="accent" class="lg rounded btn-block mt-2" type="button"
					(click)="_continue()">
				{{ 'goto-payment' | translate }}
			</button>
		}
	}
</div>
}

<div class="spacer-bottom"></div>

} @else {
	<div class="p-4">
		<div class="animated faster fadeInUp my-panel mb-4">
			<div class="my-panel-body text-center">
				<div class="text-center  mb-4">
					<div class="text-xl font-bold">{{ '_LOYALTY.welcome' | translate }}</div>
					{{ '_LOYALTY.sprompt_desc_tabitorder' | translate }}
				</div>

				<div class="mt-4">
					<button type="button" mat-flat-button color="accent" (mousedown)="dialogsService.login()" class="rounded">
						<div class="text-base" style="white-space:normal; line-height: 1.2; font-weight:500">
							<div [innerHTML]="'_LOYALTY.sprompt_ok_tabitorder' | translate | safeHtml"></div>
						</div>
					</button>
				</div>

				<div class="text-xs text-center mt-4">
					<div>{{ '_LOYALTY.sprompt_license_tabitorder' | translate }}</div>
					<div class="flex a-center j-center">
						<a class="inline link mr-2"
						   (click)="appService.showContractDialog('contract')">{{ 'READ_AND_APPROVE_CONTRACT_C' | translate }}</a>
						<a class="inline link"
						   (click)="appService.showContractDialog('privacy')">{{ 'READ_AND_APPROVE_CONTRACT_D' | translate }}</a>
					</div>
				</div>
			</div>
		</div>
	</div>
}

